var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.205078)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9078",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.205078",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9078)" } }, [
        _c("path", {
          attrs: {
            d: "M0.205078 7.62939e-06L0.205078 46L46.2037 46L46.2037 7.62939e-06L0.205078 7.62939e-06Z",
            fill: "#1E284B",
          },
        }),
        _c("path", {
          attrs: { d: "M0.20649 46H46.2051V0H0.20649V46Z", fill: "#96DE06" },
        }),
        _c("path", {
          attrs: { d: "M46.2051 46H0.20649V0L46.2051 46Z", fill: "#C6FB31" },
        }),
        _c("path", {
          attrs: {
            d: "M0.20541 24.853V46H21.3516L0.20541 24.853Z",
            fill: "#96DE06",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }